import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/inventory');

export const getInventoryRequirements = actionCreator.async<{}, number>('GET_INVENTORY_REQUIREMENTS');
